import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Invoices } from '../../../../../ui'

const invoicesSearchSchema = z.object({
	filter: z.enum(['open', 'overdue']).optional(),
	showHidden: z.boolean().optional(),
})

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/invoices',
)({
	validateSearch: invoicesSearchSchema,
	search: {
		middlewares: [({ next, search }) => {
			const cleaned: Record<string, unknown> = { ...search }
			if (!cleaned.filter) { delete cleaned.filter }
			if (!cleaned.showHidden) { delete cleaned.showHidden }
			return next(cleaned)
		}],
	},
	component: RouteComponent,
})

function RouteComponent() {
	return <Invoices />
}
